var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetch } from '@mitchell/typescript.service.fetch';
import { HttpCacheType, HttpMethodType, HttpContentType, HttpHeaderType, handleResponse, EnvironmentService } from "../../common";
export class PhotoCapturePhotoUploadService {
    constructor(fetchWrapper = fetch) {
        this.fetchWrapper = fetchWrapper;
    }
    static getInstance() {
        if (!PhotoCapturePhotoUploadService.INSTANCE) {
            PhotoCapturePhotoUploadService.INSTANCE = new PhotoCapturePhotoUploadService();
        }
        return PhotoCapturePhotoUploadService.INSTANCE;
    }
    photoCapturePhotoUploadData(contextId, coCode, header) {
        return __awaiter(this, void 0, void 0, function* () {
            const uri = `${EnvironmentService.getEnvironment().connectServicesUrl}v1.0/apd/photocapture/companies/${coCode}/apd/coCode/${coCode}/GPCContext/${contextId}/upload-attachments`;
            const request = new Request(uri, {
                method: HttpMethodType.POST,
                cache: HttpCacheType.NO_CACHE,
                headers: new Headers({
                    [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
                    accept: HttpContentType.APPLICATION_JSON,
                    Pragma: HttpCacheType.NO_CACHE,
                    applicationName: header.applicationName,
                    sourceName: header.sourceName,
                    saveToEds: header.saveToEds
                })
            });
            return yield this.fetchWrapper(request).then(response => handleResponse(response));
        });
    }
}
//# sourceMappingURL=PhotoCapturePhotoUploadService.js.map